import { useMemo } from "react";
import { useUserStore } from "../store/userStore";
import { User } from "../types/user";

export function useUserDevices(user: { email?: string; phone?: string }) {
  const { users } = useUserStore();

  return useMemo(() => {
    if (!user.email && !user.phone) return [];

    // Step 1: Match users by email (preferred) or phone
    const matchedUsers: User[] = users.filter(u => {
      if (user.email) {
        return u.email?.toLowerCase() === user.email.toLowerCase();
      }
      if (user.phone) {
        return u.phone === user.phone;
      }
      return false;
    });

    // Step 2: Flatten all devices from matched users
    const matchedDevices = matchedUsers.flatMap(u => u.devices ?? []);

    return matchedDevices;
  }, [users, user]);
}
